import styled from 'styled-components';

export const GRID_MAX_COLUMNS = 6;
export const GRID_GAP = '1rem';
export const GRID_MIN_TILE_WIDTH = '13rem';

export const UploadsGridLayout = styled.div`
    display: grid;
    /* Max 6 per riga; su viewport larghi i tile crescono, su stretti scendono sotto le 6 colonne */
    grid-template-columns: repeat(
        auto-fill,
        minmax(
            max(
                ${GRID_MIN_TILE_WIDTH},
                calc((100% - (${GRID_MAX_COLUMNS} - 1) * ${GRID_GAP}) / ${GRID_MAX_COLUMNS})
            ),
            1fr
        )
    );
    gap: ${GRID_GAP};
    align-items: start;
`;

export const UploadsGridTileButton = styled.button`
    appearance: none;
    border: 1px solid rgba(0, 0, 0, 0.06);
    background: #fafafa;
    padding: 0.65rem;
    text-align: left;
    cursor: pointer;
    transition:
        box-shadow 0.2s ease,
        border-color 0.2s ease;

    &:hover {
        border-color: ${(props) => props.theme.PrimaryColor};
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    }

    &.is-selected {
        border-color: ${(props) => props.theme.PrimaryColor};
        box-shadow: 0 0 0 1px ${(props) => props.theme.PrimaryColor};
    }

    .upload-tile-thumb-wrap {
        position: relative;
    }

    .upload-tile-thumb {
        aspect-ratio: 4 / 3;
        overflow: hidden;
        background: #fff;
        border: 1px solid rgba(0, 0, 0, 0.06);
        display: flex;
        align-items: center;
        justify-content: center;

        img,
        video {
            inline-size: 100%;
            block-size: 100%;
            object-fit: cover;
        }

        .media-video-icon {
            position: absolute;
            inset: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 1.4rem;
            text-shadow: 0 1px 6px rgba(0, 0, 0, 0.5);
        }
    }

    .upload-tile-encoding {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.65);
        color: #fff;
        text-align: center;
        padding: 0.5rem;

        h1 {
            font-size: 0.85rem;
            margin: 0;
            font-weight: 500;
            line-height: 1.35;
            color: #fff;
        }

        small {
            font-size: 0.65rem;
            text-transform: uppercase;
            color: #fff;
            margin-bottom: 0.5rem;
        }
    }

    .upload-tile-title {
        margin-top: 0.55rem;
        font-size: ${(props) => props.theme.FontSizeSm};
        line-height: 1.35;
        color: ${(props) => props.theme.TextColor};
        min-width: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .upload-tile-meta {
        margin-top: 0.25rem;
        font-size: ${(props) => props.theme.FontSizeXSm};
        color: ${(props) => props.theme.TextColorMuted};
        text-transform: uppercase;
    }

    .count-badge {
        width: 30px;
        height: 30px;
        border-radius: 100%;
        background: ${(props) => props.theme.PrimaryColor};
        position: absolute;
        top: -10px;
        right: -10px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        color: #fff;
        z-index: 2;

        .icon {
            display: none;
        }

        &:hover {
            background: ${(props) => props.theme.DangerColor};

            .number {
                display: none;
            }

            .icon {
                display: flex;
            }
        }
    }
`;
